import {
  Avatar,
  Box,
  Button,
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useState } from "react";
import { useEffect } from "react";
import { ImCancelCircle } from "react-icons/im";

function JoinMeetingPopup({ ...props }) {
  const containerColor = useColorModeValue("#fff", "#000");
  const textColor1 = useColorModeValue("#294566", "#5481B6");
  const textColor2 = useColorModeValue("#294566", "#A3B6CC");
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 3000);
  }, []);

  return (
    show && (
      <Flex
        boxShadow="2px 2px 20px #00000012"
        width={["300px", "370px"]}
        bg={containerColor}
        p="10px"
        borderRadius={"20px"}
        justify="center"
        alignItems={"center"}
        position="absolute"
        zIndex={"9"}
        top="30px"
        left={"10px"}
        className=" animate__animated   animate__bounceIn animate__fast"
        gap="10px"
        {...props}
      >
        <Flex flexDirection={"row"} alignItems="center" gap="5px">
          <Avatar name="John Doe" />
          <Box textAlign="left" color={textColor1}>
            <Text fontWeight={"700"} fontSize=".8em">
              Someone wants to join the meeting
            </Text>
            <Text fontWeight={"normal"} fontSize=".8em" color={textColor2}>
              John Doe
            </Text>
          </Box>
        </Flex>
        <Button
          size={"xs"}
          fontSize={".9em"}
          p="10px 17px"
          bg="#50BB69"
          color="#fff"
        >
          Accept
        </Button>

        <Box pos="relative">
          <Box
            pos="absolute"
            top={-10}
            right={-7}
            zIndex={100}
            bg={containerColor}
            borderRadius={"50%"}
            border={`3px solid ${containerColor}`}
            cursor="pointer"
            onClick={() => setShow(false)}
          >
            <ImCancelCircle size={22} color="#FF5E61" cursor={"pointer"} />
          </Box>
        </Box>
      </Flex>
    )
  );
}

export default JoinMeetingPopup;
